// App-wide configuration constants.

// Emoji reactions available in the DayTrading chat.
// The first three entries are shown as quick-reactions on hover; the rest are
// reachable via the "more" picker popup.
export const CHAT_REACTION_EMOJIS: string[] = [
  '👍', '❤️', '🚀', '🎉', '🔥',
  '😂', '😮', '😢', '👎', '💯',
  '🙏', '👀', '🎉',  '💶', '💸'
];
